module.exports = "<div> <div class=holding-dashboard-hero-bg></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/directives/dashboard-hero-bg/dashboard-hero-bg.html
// module id = 849
// module chunks = 0